
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'LighteningScanModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['closeVirusScanModal', 'scanTerminal'],
  setup (props, context) {
    const modalVisiable = computed(() => props.show)
    return {
      modalVisiable,
      closeModal () {
        context.emit('closeVirusScanModal', 'MODAL_LIGHTENING_SCAN')
      },
      quickScan () {
        context.emit('scanTerminal', 1)
        context.emit('closeVirusScanModal', 'MODAL_LIGHTENING_SCAN')
      }
    }
  }
})
